import React from 'react';
import '../style/WrongPage.scss';
const WrongPage = () => {
    return (
        <>
            <h1>Page not Found</h1>
        </>
    );
}

export default WrongPage;